/* Imports */
import RoleService from "@/services/role.service";
/* /Imports/ */

/* 
  Module: RolesTableModule
  Description: This module representing different actions with roles.
*/
export const rolesTable = {
    /*
      Self-contained/reusable module.
    */
    namespaced: true,

    /*
      Default states in this module.
    */
    state: {
        rolesData: null,
    },

    /*
      Define actions for separate different logic. 
    */
    actions: {
        /* 
          Call RoleService class then dispatch all roles action.
        */
        getAllRoles({ commit }) {
            return RoleService.getAllRoles().then(
                (response) => {
                    commit("dataSuccess", response.data.roles);
                    return Promise.resolve(response.data.roles);
                }
            )
        },

    },

    /*
      Define mutations for separate different states. 
    */
    mutations: {
        /* 
          If data for all roles is successfully obtained.
        */
        dataSuccess(state, rolesData) {
            state.rolesData = rolesData;
        },
    }
};
